module.exports = __webpack_public_path__ + "img/129.3510e542.jpg";